// import React, { useState } from "react";
// import { Icon } from "@iconify/react";
// import Swal from "sweetalert2";
// import "../electricityprovider/electricityProvider.scss"; // Correct SCSS import
// import { api, fetchData } from "../helper/api.interceptor";

// const AddProviderModal = ({ show, onClose, onProviderAdded }) => {
//     const [form, setForm] = useState({
//         name: '',
//         code: '',
//         billingCycles: [],
//         image: null,
//         imagePreview: null,
//     });
//     const [loading, setLoading] = useState(false);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm({ ...form, [name]: value });
//     };

//     const handleBillingCycleToggle = (cycle) => {
//         setForm((prev) => {
//             const updated = prev.billingCycles.includes(cycle)
//                 ? prev.billingCycles.filter((c) => c !== cycle)
//                 : [...prev.billingCycles, cycle];
//             return { ...prev, billingCycles: updated };
//         });
//     };

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 setForm({
//                     ...form,
//                     image: file,
//                     imagePreview: reader.result,
//                 });
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!form.name || !form.code || form.billingCycles.length === 0 || !form.image) {
//             return Swal.fire("Missing Fields", "Please fill out all fields", "warning");
//         }

//         setLoading(true);
//         try {
//             const formData = new FormData();
//             formData.append("name", form.name);
//             formData.append("code", form.code);
//             formData.append("billingCycles", JSON.stringify(form.billingCycles.map((label) => ({ label }))));
//             formData.append("image", form.image);

//             const response = await fetchData.postWithFormData("/add-electricity-providers", formData);

//             if (response?.status_code == 200) {
//                 Swal.fire("Success", "Electricity provider added successfully", "success");
//                 onProviderAdded();
//                 resetForm();
//                 onClose();
//             } else {
//                 throw new Error(response?.data?.message || "Failed to add provider");
//             }
//         } catch (error) {
//             Swal.fire("Error", error.message, "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const resetForm = () => {
//         setForm({
//             name: '',
//             code: '',
//             billingCycles: [],
//             image: null,
//             imagePreview: null,
//         });
//     };

//     if (!show) return null;

//     return (
//         <div className="modal-backdrop">
//             <div className="modal-container">
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <h5 className="modal-title">Add Electricity Provider</h5>
//                         <button type="button" className="close-btn" onClick={onClose}>
//                             <Icon icon="mdi:close" />
//                         </button>
//                     </div>
//                     <div className="modal-body">
//                         <form onSubmit={handleSubmit}>
//                             <div className="form-group">
//                                 <label>Provider Name</label>
//                                 <input
//                                     type="text"
//                                     name="name"
//                                     value={form.name}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                     placeholder="Enter provider name"
//                                     required
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label>Provider Code</label>
//                                 <input
//                                     type="text"
//                                     name="code"
//                                     value={form.code}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                     placeholder="e.g. ELEC001"
//                                     required
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label>Billing Cycle</label>
//                                 <div className="toggle-group">
//                                     {["1 month", "2 month"].map((cycle) => (
//                                         <button
//                                             type="button"
//                                             key={cycle}
//                                             className={`toggle-btn ${form.billingCycles.includes(cycle) ? "active" : ""}`}
//                                             onClick={() => handleBillingCycleToggle(cycle)}
//                                         >
//                                             {cycle}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div className="form-group">
//                                 <label>Provider Logo</label>
//                                 <div className="file-upload">
//                                     {form.imagePreview ? (
//                                         <div className="image-preview-container">
//                                             <img src={form.imagePreview} alt="Preview" className="image-preview" />
//                                             <button
//                                                 type="button"
//                                                 className="remove-image-btn"
//                                                 onClick={() => setForm({ ...form, image: null, imagePreview: null })}
//                                             >
//                                                 <Icon icon="mdi:close" />
//                                             </button>
//                                         </div>
//                                     ) : (
//                                         <>
//                                             <input
//                                                 type="file"
//                                                 accept="image/*"
//                                                 onChange={handleFileChange}
//                                                 id="provider-image"
//                                                 className="file-input"
//                                             />
//                                             <label htmlFor="provider-image" className="upload-label">
//                                                 <Icon icon="solar:upload-linear" />
//                                                 <span>Upload Logo</span>
//                                             </label>
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                     <div className="modal-footer">
//                         <button type="button" className="btn btn-secondary" onClick={onClose}>
//                             Close
//                         </button>
//                         <button
//                             type="button"
//                             className="btn btn-primary"
//                             onClick={handleSubmit}
//                             disabled={loading}
//                         >
//                             {loading ? (
//                                 <>
//                                     <Icon icon="eos-icons:loading" className="spinner" />
//                                     Adding...
//                                 </>
//                             ) : (
//                                 "Add Provider"
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AddProviderModal;
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import "../electricityprovider/electricityProvider.scss";
import Select from "react-select";
import indiaLocations from "../data/indiaLocations.json";
import { fetchData } from "../helper/api.interceptor";

const AddProviderModal = ({ show, onClose, onProviderAdded }) => {
    const [form, setForm] = useState({
        name: "",
        code: "",
        state: "",
        cities: [], // this will store selected districts
        billingCycles: [],
        image: null,
        imagePreview: null,
    });
    const [availableCities, setAvailableCities] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ When state changes → load all district names as city options
    useEffect(() => {
        if (form.state) {
            const stateObj = indiaLocations.find((s) => s.state === form.state);
            if (stateObj && Array.isArray(stateObj.districts)) {
                const allDistrictNames = stateObj.districts.map((d) => d.district);
                setAvailableCities(allDistrictNames);
            } else {
                setAvailableCities([]);
            }
        } else {
            setAvailableCities([]);
        }
        setForm((prev) => ({ ...prev, cities: [] }));
    }, [form.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleBillingCycleToggle = (cycle) => {
        setForm((prev) => {
            const updated = prev.billingCycles.includes(cycle)
                ? prev.billingCycles.filter((c) => c !== cycle)
                : [...prev.billingCycles, cycle];
            return { ...prev, billingCycles: updated };
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setForm({
                    ...form,
                    image: file,
                    imagePreview: reader.result,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.name || !form.code || !form.state || !form.image) {
            return Swal.fire("Missing Fields", "Please fill all required fields", "warning");
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("name", form.name);
            formData.append("code", form.code);
            formData.append("state", form.state);
            formData.append("cities", JSON.stringify(form.cities.map((c) => c.value)));
            formData.append(
                "billingCycles",
                JSON.stringify(form.billingCycles.map((label) => ({ label })))
            );
            formData.append("image", form.image);

            const response = await fetchData.postWithFormData(
                "/add-electricity-providers",
                formData
            );

            if (response?.status_code === 200) {
                Swal.fire("Success", "Electricity provider added successfully", "success");
                onProviderAdded();
                resetForm();
                onClose();
            } else {
                throw new Error(response?.data?.message || "Failed to add provider");
            }
        } catch (error) {
            Swal.fire("Error", error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setForm({
            name: "",
            code: "",
            state: "",
            cities: [],
            billingCycles: [],
            image: null,
            imagePreview: null,
        });
        setAvailableCities([]);
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-container">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Electricity Provider</h5>
                        <button type="button" className="close-btn" onClick={onClose}>
                            <Icon icon="mdi:close" />
                        </button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {/* Provider name */}
                            <div className="form-group">
                                <label>Provider Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter provider name"
                                    required
                                />
                            </div>

                            {/* Provider code */}
                            <div className="form-group">
                                <label>Provider Code</label>
                                <input
                                    type="text"
                                    name="code"
                                    value={form.code}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="e.g. ELEC001"
                                    required
                                />
                            </div>

                            {/* State dropdown */}
                            <div className="form-group">
                                <label>State</label>
                                <Select
                                    options={indiaLocations.map((s) => ({
                                        label: s.state,
                                        value: s.state,
                                    }))}
                                    value={form.state ? { label: form.state, value: form.state } : null}
                                    onChange={(selected) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            state: selected?.value || "",
                                            cities: [],
                                        }))
                                    }
                                    placeholder="Select State"
                                    isClearable
                                />
                            </div>

                            {/* City dropdown (shows all districts) */}
                            <div className="form-group">
                                <label>Cities</label>
                                <Select
                                    isMulti
                                    options={availableCities.map((c) => ({
                                        label: c,
                                        value: c,
                                    }))}
                                    value={form.cities}
                                    onChange={(selected) => setForm({ ...form, cities: selected || [] })}
                                    placeholder={
                                        form.state
                                            ? "Select one or more Cities"
                                            : "Select a state first"
                                    }
                                    isDisabled={!availableCities.length}
                                />
                            </div>

                            {/* Billing cycles */}
                            <div className="form-group">
                                <label>Billing Cycle</label>
                                <div className="toggle-group">
                                    {["1 month", "2 month"].map((cycle) => (
                                        <button
                                            type="button"
                                            key={cycle}
                                            className={`toggle-btn ${form.billingCycles.includes(cycle) ? "active" : ""
                                                }`}
                                            onClick={() => handleBillingCycleToggle(cycle)}
                                        >
                                            {cycle}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Provider logo */}
                            <div className="form-group">
                                <label>Provider Logo</label>
                                <div className="file-upload">
                                    {form.imagePreview ? (
                                        <div className="image-preview-container">
                                            <img
                                                src={form.imagePreview}
                                                alt="Preview"
                                                className="image-preview"
                                            />
                                            <button
                                                type="button"
                                                className="remove-image-btn"
                                                onClick={() =>
                                                    setForm({
                                                        ...form,
                                                        image: null,
                                                        imagePreview: null,
                                                    })
                                                }
                                            >
                                                <Icon icon="mdi:close" />
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                id="provider-image"
                                                className="file-input"
                                            />
                                            <label htmlFor="provider-image" className="upload-label">
                                                <Icon icon="solar:upload-linear" />
                                                <span>Upload Logo</span>
                                            </label>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Icon icon="eos-icons:loading" className="spinner" />
                                    Adding...
                                </>
                            ) : (
                                "Add Provider"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProviderModal;

